<template>
    <div>
        <section id="slider" class="new-container">
            <carousel class="header-carousel mb-5 carousel-block" :perPage="1" 
                        :navigationEnabled="true"
                        :navigationPrevLabel="'&#171;'"
                        :navigationNextLabel="'&#187;'"
                        :loop="true"
                        :scrollPerPage="true">
                <slide>
                   <img src="assets/landing/images/banner2.jpg" alt="img" class="w-100 slide-img">
                </slide>
                <slide>
                   <img src="assets/landing/images/banner1.jpg" alt="img" class="w-100 slide-img">
                </slide>
                <slide>
                   <img src="assets/landing/images/banner3.jpg" alt="img" class="w-100 slide-img">
                </slide>
                <slide>
                   <img src="assets/landing/images/banner4.jpg" alt="img" class="w-100 slide-img">
                </slide>
            </carousel> 
        </section>
        <section id="feature">
            <div>
                <div class="d-flex flex-column w-100">
                    <div>
                        <div class="title-bg">
                            <h2 class="new-title"> {{ $t('home.about_sustem.title') }} </h2>
                        </div>
                    </div>
                    <div class="new-container">
                        <div class="feature-content mb-5">
                            <div class="info-block">
                                <div class="d-flex align-items-center justify-content-center w-100">
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                </div>
                                <h3 class="new-title2 new-title2-spacing">{{ $t('home.about_sustem.subtitle') }}</h3>
                                <div class="d-flex justify-content-around mob-feature-block">
                                    <div class="new-block-style" :class="{'new-block-style-height' : forHeight && id == 1}">
                                        <div class="single-feature wow zoomIn">
                                            <h4 class="new-feat-title">{{ $t('home.opportunities_1.title_1') }}</h4>
                                            <p class="feature text-white hide" :class="{ 'd-block' : showHideFeature && id == 1}">{{ $t('home.opportunities_1.description_1') }}</p>
                                            <div class="more-block">
                                                <p class="view-more" @click="viewMore(1)">
                                                    <a class="text-white">
                                                    Մանրամասն
                                                    <img src="assets/landing/images/Vector.svg" >
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="new-block-style" :class="{'new-block-style-height' : forHeight && id == 2}">
                                        <div class="single-feature wow zoomIn">
                                            <h4 class="new-feat-title">{{ $t('home.opportunities_1.title_2') }}</h4>
                                            <p class="feature text-white hide" :class="{ 'd-block' : showHideFeature && id == 2}">{{ $t('home.opportunities_1.description_2') }}</p>
                                            <div class="more-block">
                                                <p class="view-more"  @click="viewMore(2)">
                                                    <a class="text-white">
                                                    Մանրամասն
                                                    <img src="assets/landing/images/Vector.svg" >
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="new-block-style" :class="{'new-block-style-height' : forHeight && id == 3}">
                                        <div class="single-feature wow zoomIn">  
                                            <h4 class="new-feat-title">{{ $t('home.opportunities_1.title_3') }}</h4>
                                            <p class="feature text-white hide" :class="{ 'd-block' : showHideFeature && id == 3}" >
                                            {{ $t('home.opportunities_1.description_3') }}
                                            </p>
                                            <div class="more-block">
                                                <p class="view-more" @click="viewMore(3)">
                                                    <a class="text-white">
                                                    Մանրամասն
                                                    <img src="assets/landing/images/Vector.svg" >
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="info-block">
                                <div class="d-flex align-items-center justify-content-center w-100">
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                </div>
                                <h3 class="new-title2 new-title2-spacing"> {{ $t('home.about_sustem.subtitle_2') }}</h3>
                                <div class="d-flex justify-content-around mob-feature-block">
                                    <div class="new-block-style" :class="{'new-block-style-height' : forHeight && id == 4}">
                                        <div class="single-feature wow zoomIn">
                                            <h4 class="new-feat-title"> {{ $t('home.opportunities_2.title_1') }} </h4>
                                            <p class="feature text-white hide" :class="{ 'd-block' : showHideFeature && id == 4}" >
                                            {{ $t('home.opportunities_2.description_1') }}
                                            </p>
                                            <div class="more-block">
                                                <p class="view-more" @click="viewMore(4)">
                                                    <a class="text-white">
                                                    Մանրամասն
                                                    <img src="assets/landing/images/Vector.svg" >
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="new-block-style" :class="{'new-block-style-height' : forHeight && id == 5}">
                                        <div class="single-feature wow zoomIn">
                                            <h4 class="new-feat-title">{{ $t('home.opportunities_2.title_2') }}</h4>
                                            <p class="feature text-white hide" :class="{ 'd-block' : showHideFeature && id == 5}" >
                                            {{ $t('home.opportunities_2.description_2') }}
                                            </p>
                                            <div class="more-block">
                                                <p class="view-more" @click="viewMore(5)">
                                                    <a class="text-white">
                                                    Մանրամասն
                                                    <img src="assets/landing/images/Vector.svg" >
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="new-block-style" :class="{'new-block-style-height' : forHeight && id == 6}">
                                        <div class="single-feature wow zoomIn">
                                            <h4 class="new-feat-title">{{ $t('home.opportunities_2.title_3') }} </h4>
                                            <p class="feature text-white hide" :class="{ 'd-block' : showHideFeature && id == 6}" >
                                            {{ $t('home.opportunities_2.description_3') }}
                                            </p>
                                            <div class="more-block">
                                                <p class="view-more" @click="viewMore(6)">
                                                    <a class="text-white">
                                                    Մանրամասն
                                                    <img src="assets/landing/images/Vector.svg" >
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="new-container">
            <div class="d-flex flex-column align-items-end w-100 mt-5">
                <section id="counter">
                    <div class="counter-overlay"   v-waypoint="{ active: true, callback: onWaypoint }">
                        <div>
                            <div class="d-flex justify-content-between">
                                <div class="col-md-12">
                                    <div class="counter-area">
                                        <div class="d-flex mob-counter">
                                            <!-- Start single counter -->
                                            <div>
                                                <div class="single-counter">
                                                    <div class="counter-icon">
                                                        <img src="assets/landing/images/clock.svg">
                                                    </div>
                                                    <div class="counter-no counter" >
                                                        <ICountUp :delay="1000" :endVal="activeTenders"   :options="options" ref="ICountUp1"  />
                                                    </div>
                                                    <div class="counter-label">
                                                    {{ $t('home.counter.title_1') }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="new-line"></div>
                                            <div>
                                                <div class="single-counter">
                                                    <div class="counter-icon">
                                                        <img src="assets/landing/images/bag.svg">
                                                    </div>
                                                    <div class="counter-no counter" >
                                                        <ICountUp :delay="1000" :endVal="todayTenders"   :options="options" ref="ICountUp2"  />
                                                    </div>
                                                    <div class="counter-label">
                                                    {{ $t('home.counter.title_2') }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="single-counter">
                                                    <div class="counter-icon">
                                                        <img src="assets/landing/images/reward.svg">
                                                    </div>
                                                    <div class="counter-no counter">
                                                        <ICountUp :delay="1000" :endVal="allTenders"   :options="options" ref="ICountUp3"  />
                                                    </div>
                                                    <div class="counter-label">
                                                    {{ $t('home.counter.title_3') }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="single-counter">
                                                    <div class="counter-icon">
                                                        <img src="assets/landing/images/users.svg">
                                                    </div>
                                                    <div class="counter-no counter">
                                                        <ICountUp :delay="1000" :endVal="users"   :options="options" ref="ICountUp4"  />
                                                    </div>
                                                    <div class="counter-label">
                                                    {{ $t('home.counter.title_4') }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="single-counter">
                                                    <div class="counter-icon">
                                                        <img src="assets/landing/images/user.svg">
                                                    </div>
                                                    <div class="counter-no counter">
                                                        <ICountUp :delay="1000" :endVal="usersState"   :options="options" ref="ICountUp5"  />
                                                    </div>
                                                    <div class="counter-label">
                                                    {{ $t('home.counter.title_5') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </section>
        <!-- <div class="strong-line"></div> -->
        <section id="advantage" class="new-container sp-block mob-sp mb-5 ">
            <div v-for="(i, index) in advantageContent" :key="index + Math.random()" class="advantage-block">
                <div class="advantage-image-block">
                    <img :src="i.imgSrc">
                </div>
                <p class="mb-0 text-white text-center advantage-header">{{ i.titleAdvantage }}</p>
                <div class="line"></div>
                <div v-for="(k, itemIndex) in i.items" :key="itemIndex + Math.random()" class="d-flex align-items-center advantage-item-block">
                    <img src="assets/landing/images/allow.svg">
                    <p class="mb-0 text-white advantage-content">{{ k }}</p>
                </div>
            </div>
        </section>
        <News></News>
        <div class="main-line"></div>
        <section ref="pricingTable" id="pricing-table">
            <div v-if="isAuthenticated">
                <h2 class="new-title lh new-container px-5" v-if="userType === 'STATE'">ԿԱԶՄԱԿԵՐՊԻՐ ՊԵՏԱԿԱՆ ԳՆՄԱՆ ԳՈՐԾԸՆԹԱՑՆԵՐԸ ԱՐԱԳ ԵՎ ՃՇԳՐԻՏ</h2>
                <h2 class="new-title lh new-container px-5" v-else>Ստացիր բիզնեսի զարգացման նոր հնարավորություններ</h2>
            </div>
            <div v-if="!isAuthenticated">
                <h2 class="new-title lh new-container px-5">ԿԱԶՄԱԿԵՐՊԻՐ ՊԵՏԱԿԱՆ ԳՆՄԱՆ ԳՈՐԾԸՆԹԱՑՆԵՐԸ ԱՐԱԳ ԵՎ ՃՇԳՐԻՏ</h2>
                <div class="new-container packages-sp packages overflow mob-sp">
                    <div v-for="(item, itemIndex) in packageBlockContentForState" :key="itemIndex + Math.random()" class="package-block">
                        <div v-if="!me.probation && item.freePeriod !== undefined && me.package === 'Անվճար'" @click="activateStateFreePeriod" class="free-period">
                            {{item.freePeriod}}
                        </div>
                        <div class="package-header-block"> 
                            <h1>{{item.packageHeader}}</h1>
                            <h2>{{item.sum + ' ' + 'Դրամ/Տարի'}}</h2>
                        </div>
                        <div class="d-flex flex-column align-items-end">
                            <p class="package-content new-package-content mb-0 package-content-state" style="height: 300px">{{item.packageContent}}</p>
                            <router-link tag="button" :to="{path: '/packages/state'}" class="more-info-btn" :class="{ 'mb-2' : item.changeBoolean && item.packageHeader !== 'Անվճար փաթեթ', 'view-more-spacing' : true}">
                                Մանրամասն
                                <img src="assets/landing/images/arrow.svg">
                            </router-link>
                        </div>
                        <div v-if="isAuthenticated === true">
                            <button @click="()=>{$modal.show('payment-state-modal', item.sum );isLoaded=false;}" class="package-btn cursor">
                            ԳՆԵԼ
                            </button>
                        </div>
                        <div v-else>
                            <button @click="buyPackage" class="package-btn cursor">
                            ԳՆԵԼ
                            </button>
                        </div>
                    </div>
                </div>   
                <h2 class="new-title lh new-container px-5">Ստացիր բիզնեսի զարգացման նոր հնարավորություններ</h2>  
                <div v-if="pricings.length"  class="new-container packages-sp packages overflow mob-sp">
                    <div v-for="(item, itemIndex) in packageBlockContent" :key="item + Math.random()" class="package-block"  @mouseleave=" () => hidePrices(item)" :class="{ 'new-height' : changeStyles}">
                        <div v-if="!me.probation && item.freePeriod !== undefined && me.package === 'Անվճար'" @click="activateFreePeriod" class="free-period">
                            {{item.freePeriod}}
                        </div>
                        <div class="package-header-block"> 
                            <h1>{{item.packageHeader}}</h1>
                            <h2>{{item.packageText}}</h2>
                        </div>
                        <div class="d-flex flex-column align-items-end">
                            <p class="package-content mb-0">{{item.packageContent}}</p>
                            <router-link tag="button" :to="{path: '/packages/private'}" class="more-info-btn" :class="{ 'mb-2' : item.changeBoolean && item.packageHeader !== 'Անվճար փաթեթ', 'view-more-spacing' : true}">
                                Մանրամասն
                                <img src="assets/landing/images/arrow.svg">
                            </router-link>
                        </div>
                        <button class="package-btn cursor" @click="() => viewPrices(item)" :class="{'d-none' : item.changeBoolean && item.packageHeader !== 'Անվճար փաթեթ'}">{{item.buttonContent}}</button>
                        <div v-if="isAuthenticated === true && me.package === 'Անվճար'">
                            <button :disabled="!item.cash" @click="()=>{$modal.show('payment-modal', {packageId, selectedPrice});isLoaded=false;}" class="justify-content-between pay-btn align-items-center cursor" v-if="item.packageHeader !== 'Անվճար փաթեթ'" :class="{'d-flex' : item.changeBoolean}" >
                                <p>{{ item.cash }}</p>
                                <p class="ml-2">վճարել</p>
                            </button>
                        </div>
                        <div v-else-if="isAuthenticated === true && me.package !== 'Անվճար'">
                            <button :disabled="!item.cash" @click="withActivatePackage" class="justify-content-between pay-btn align-items-center cursor" v-if="item.packageHeader !== 'Անվճար փաթեթ'" :class="{'d-flex' : item.changeBoolean}" >
                                <p>{{ item.cash }}</p>
                                <p class="ml-2">վճարել</p>
                            </button>
                        </div>
                        <div v-else>
                            <button @click="buyPackage" class="justify-content-between pay-btn align-items-center cursor" v-if="item.packageHeader !== 'Անվճար փաթեթ'" :class="{'d-flex' : item.changeBoolean}" >
                                <p>{{ item.cash }}</p>
                                <p class="ml-2">վճարել</p>
                            </button>
                        </div>
                        <div class="package-sum-block" v-if="item.sumAndMonth !== undefined " :class="{'d-block' : item.changeBoolean}">
                            <div v-for="(k, index) in item.sumAndMonth" :key="index + Math.random()" class="d-flex align-items-center pb-4">
                                <input type="radio" class="blue-circle cursor" name="price" @click="() => getSum(k, item, pricings[itemIndex])">
                                <p class="sum-text mb-0 "><span>{{ k[2] }} ամիս՝</span> {{Math.round(pricings[itemIndex].price[`price_${k[2]}`].price / pricings[itemIndex].price[`price_${k[2]}`].month)}} դր/ամիս</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="isAuthenticated && userType === 'STATE'">
                <div class="new-container packages-sp packages overflow mob-sp">
                    <div v-for="(item, itemIndex) in packageBlockContentForState" :key="itemIndex + Math.random()" class="package-block">
                        <div v-if="!me.probation && item.freePeriod !== undefined && me.package === 'Անվճար'" @click="activateStateFreePeriod" class="free-period">
                            {{item.freePeriod}}
                        </div>
                        <div class="package-header-block"> 
                            <h1>{{item.packageHeader}}</h1>
                            <h2>{{item.sum + ' ' + 'Դրամ/Տարի'}}</h2>
                        </div>
                        <div class="d-flex flex-column align-items-end">
                            <p class="package-content new-package-content mb-0 package-content-state" style="height: 300px">{{item.packageContent}}</p>
                            <router-link tag="button" :to="{path: '/packages/state'}" class="more-info-btn" :class="{ 'mb-2' : item.changeBoolean && item.packageHeader !== 'Անվճար փաթեթ', 'view-more-spacing' : true}">
                                Մանրամասն
                                <img src="assets/landing/images/arrow.svg">
                            </router-link>
                        </div>           
                        <div v-if="isAuthenticated === true">
                            <button @click="()=>{$modal.show('payment-state-modal', item.id );isLoaded=false;}" class="package-btn cursor">
                            վճարել
                            </button>
                        </div>
                        <div v-else>
                            <button @click="buyPackage" class="package-btn cursor">
                            վճարել
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="isAuthenticated && userType === 'USER'">
                <div v-if="pricings.length" class="new-container packages-sp packages overflow mob-sp">
                    <div v-for="(item, itemIndex) in packageBlockContent" :key="item + Math.random()" class="package-block"  @mouseleave=" () => hidePrices(item)" :class="{ 'new-height' : changeStyles}">
                        <div v-if="!me.probation && item.freePeriod !== undefined && me.package === 'Անվճար'" @click="activateFreePeriod" class="free-period">
                            {{item.freePeriod}}
                        </div>
                        <div class="package-header-block"> 
                            <h1>{{item.packageHeader}}</h1>
                            <h2>{{item.packageText}}</h2>
                        </div>
                        <div class="d-flex flex-column align-items-end">
                            <p class="package-content mb-0">{{item.packageContent}}</p>
                            <router-link tag="button" :to="{path: '/packages/private'}" class="more-info-btn" :class="{ 'mb-2' : item.changeBoolean && item.packageHeader !== 'Անվճար փաթեթ', 'view-more-spacing' : true}">
                                Մանրամասն
                                <img src="assets/landing/images/arrow.svg">
                            </router-link>
                        </div>
                        <button class="package-btn cursor" @click="() => viewPrices(item)" :class="{'d-none' : item.changeBoolean && item.packageHeader !== 'Անվճար փաթեթ'}">{{item.buttonContent}}</button>
                        <div v-if="isAuthenticated === true && me.package === 'Անվճար'">
                            <button :disabled="!item.cash" @click="()=>{$modal.show('payment-modal', {packageId, selectedPrice});isLoaded=false;}" class="justify-content-between pay-btn align-items-center cursor" v-if="item.packageHeader !== 'Անվճար փաթեթ'" :class="{'d-flex' : item.changeBoolean}" >
                                <p>{{ item.cash }}</p>
                                <p class="ml-2">վճարել</p>
                            </button>
                        </div>
                        <div v-else-if="isAuthenticated === true && me.package !== 'Անվճար'">
                            <button :disabled="!item.cash" @click="withActivatePackage" class="justify-content-between pay-btn align-items-center cursor" v-if="item.packageHeader !== 'Անվճար փաթեթ'" :class="{'d-flex' : item.changeBoolean}" >
                                <p>{{ item.cash }}</p>
                                <p class="ml-2">վճարել</p>
                            </button>
                        </div>
                        <div v-else>
                            <button @click="buyPackage" class="justify-content-between pay-btn align-items-center cursor" v-if="item.packageHeader !== 'Անվճար փաթեթ'" :class="{'d-flex' : item.changeBoolean}" >
                                <p>{{ item.cash }}</p>
                                <p class="ml-2">վճարել</p>
                            </button>
                        </div>
                        <div class="package-sum-block" v-if="item.sumAndMonth !== undefined " :class="{'d-block' : item.changeBoolean}">
                            <div v-for="(k, index) in item.sumAndMonth" :key="index + Math.random()" class="d-flex align-items-center pb-4">
                                <input type="radio" class="blue-circle cursor" name="price" @click="() => getSum(k, item, pricings[itemIndex])">
                                <p class="sum-text mb-0 "><span>{{ k[2] }} ամիս՝</span> {{Math.round(pricings[itemIndex].price[`price_${k[2]}`].price / pricings[itemIndex].price[`price_${k[2]}`].month)}} դր/ամիս</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="new-container d-flex justify-content-between align-items-start">
                <div class="d-flex justify-content-between align-items-center w-100 flex-wrap mt-5 mb-5">
                    <label for="send" class="font-size">Բաժանորդագրվել նոր հրապարակումներին</label>
                    <div class="send-block">
                        <input type="text" class="send-input" id="send" placeholder="մուտքագրեք Ձեր էլ. փոստի հասցեն" v-model="email">
                        <label for="send" class="send-label" @click="submitEmail">ՈՒՂԱՐԿԵԼ</label>
                    </div>
                </div>
                <p v-if="!$v.email.email" class="text-danger mt-3 text-right">Մուտքագրված էլ. փոստի հասցեն սխալ է</p>
            </div>
        </section>
        <section id="latest-news02" class="d-flex flex-column">
            <div>
                <div>
                    <div>
                        <div class="title-bg">
                            <h2 class="new-title">{{ $t('home.video.title') }}</h2>
                        </div>
                    </div>
                    <div class="new-container">
                        <div class="latest-news-content">
                            <div class="d-flex justify-content-around latest-video-content__sider new-container video-spacing video-sp">
                                <div>
                                    <article class="blog-news-single">
                                        <iframe width="360" height="315" src="https://www.youtube.com/embed/JCzX-KckpfU"
                                                frameborder="0" allow="autoplay; encrypted-media" allowfullscreen="" class="radius new-video-size"></iframe>
                                    </article>
                                </div>
                                <div>
                                    <article class="blog-news-single">

                                        <iframe width="360" height="315" src="https://www.youtube.com/embed/EO-zBCmk6hg"
                                                frameborder="0" allow="autoplay; encrypted-media" allowfullscreen="" class="radius new-video-size"></iframe>
                                    </article>
                                </div>
                                <div>
                                    <article class="blog-news-single">
                                        <iframe width="360" height="315" src="https://www.youtube.com/embed/iyvxJZouJF8"
                                                frameborder="0" allow="autoplay; encrypted-media" allowfullscreen="" class="radius new-video-size"></iframe>
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <!-- <section id="pricing-table">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div>
                            <h2 class="new-title"> {{ $t('home.pricing-table_1.title') }}</h2>
                            <span class="line"></span>
                        </div>
                    </div>
                    <div v-if="false && (!isAuthenticated || (isAuthenticated && userType === 'STATE'))" class="col-md-12">
                        <h3 class="title">{{ $t('home.pricing-table_1.state.title') }}</h3>
                        <div class="feature-content">
                            <div class="row">
                                <h3 class="title col-lg-12">{{ $t('home.pricing-table_1.state.subtitle') }}</h3>
                                <div class="col-md-4 col-sm-6">
                                    <div class="single-feature wow zoomIn">
                                        <i class="fa fa-pencil-square-o feature-icon"></i>
                                        <h4 class="feat-title">{{ $t('home.pricing-table_1.state.title_1') }}</h4>

                                        <p class="plan">{{ $t('home.pricing-table_1.state.description_1') }}</p>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6">
                                    <div class="single-feature wow zoomIn">
                                        <i class="fa fa-sitemap feature-icon"></i>
                                        <h4 class="feat-title">{{ $t('home.pricing-table_1.state.title_2') }}</h4>
                                        <p class="plan">{{ $t('home.pricing-table_1.state.description_2') }}</p>

                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6">
                                    <div class="single-feature wow zoomIn">
                                        <i class="fa fa-file-text-o feature-icon"></i>
                                        <h4 class="feat-title">{{ $t('home.pricing-table_1.state.title_3') }}</h4>
                                        <p class="plan">{{ $t('home.pricing-table_1.state.description_3') }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <PricingState is_state="false"></PricingState>
                    </div>
                    <div v-if="!isAuthenticated || (isAuthenticated && userType === 'USER')" class="col-md-12">
                        <h3 class="title "> {{ $t('home.pricing-table_1.private.title') }}</h3>
                        <div class="feature-content">
                            <div class="row">
                                <h3 class="title col-lg-12">{{ $t('home.pricing-table_1.private.subtitle') }}</h3>
                                <div class="col-md-12 col-sm-12">
                                    <div class="single-feature wow zoomIn">
                                        <p class="plan">{{ $t('home.pricing-table_1.private.description_1') }}</p>
                                        <p class="plan">{{ $t('home.pricing-table_1.private.description_2') }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Pricing is_state="false"></Pricing>
                    </div>
                </div>
            </div>
        </section>

        <section id="subscribe">
            <div class="subscribe-overlay">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="subscribe-area">
                                <h2 class="wow fadeInUp">{{ $t('home.subscribe-area.title') }}</h2>
                                <form action="" class="subscrib-form wow fadeInUp" data-wow-duration="0.5s"
                                    data-wow-delay="0.5s">
                                    <input type="text" :placeholder="$t('home.subscribe-area.placeholder')">
                                    <button class="subscribe-btn" type="submit">{{ $t('home.btn_send') }}</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
        <section>
            <div class="title-bg">
                <h2 class="new-title">Մեր գործընկերները</h2>
            </div>
            <div class="my-5 new-container">
                <carousel
                    class="partners block-container row"
                    :perPageCustom="[[570, 2],[810, 3], [1100, 4], [1400, 5]]"
                    :autoplay="true"
                    :autoplayTimeout="3000"
                    :autoplayHoverPause="true"
                    :centerMode="true"
                    :navigationEnabled="false"
                    :paginationEnabled="true"
                    :loop="true"
                >
                    <slide
                        v-for="(partner, index) in partners" :key="index + Math.random()"  
                        class="col-3 h-100 px-3 align-content-center" 
                    >
                        <img class="col w-100 filter" :src="`${imageUrl}/uploads/coWorkers/${partner.image}`"> 
                    </slide>
                </carousel>
            </div>
        </section>
        <payment-modal/>
        <payment-state-modal/>
    </div>
</template>

<script>

import News from '@/components/landing/News'
// import Pricing from '@/components/landing/Pricing'
// import PricingState from '@/components/landing/PricingState'
import { required, email } from 'vuelidate/lib/validators'
import { Carousel, Slide } from 'vue-carousel';

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import WOW from 'wowjs';
import PaymentModal from '../../private/participant/tenders/modals/PaymentModal'
import PaymentStateModal from '../../private/participant/tenders/modals/PaymentStateModal'


export default {
    async mounted() {
        new WOW.WOW({
            live: false,
        }).init()
        this.$store.dispatch('pricing/get').then(data => {
            this.packageBlockContent[1].packageText = 'Սկսած ' + Math.round( parseInt(this.pricings[1].price.price_12.price) / 12) + ' դրամից'
            this.packageBlockContent[2].packageText = 'Սկսած ' + Math.round( parseInt(this.pricings[2].price.price_12.price) / 12) + ' դրամից'
            this.packageBlockContent[3].packageText = 'Սկսած ' + Math.round( parseInt(this.pricings[3].price.price_12.price) / 12) + ' դրամից'
        })
        this.$client.get('co-workers').then(({data}) => {
            this.partners = data
        })

        await this.$client.get('package/state').then(response => {
            this.statePrices = response.data
        })

        for(var index = 0; index < this.packageBlockContentForState.length; index++){
            this.packageBlockContentForState[index].sum = this.statePrices[index].price
            this.packageBlockContentForState[index].id = this.statePrices[index].id
        }
        if(this.$route.query.order){
            if(this.$route.query.order === 'done'){
                this.$fire({
                    text: "Շնորհակալություն, Ձեր վճարումը հաջողությամբ կատարված է",
                    type: "success",
                    confirmButtonText: 'Լավ',
                })
            }   else {
                this.$fire({
                    text: "Վճարումը չստացվեց",
                    type: "error",
                    confirmButtonText: 'Լավ',
                })
            }
        } 
        await this.$client.get('site/info').then(response => {
            this.usersState = response.data.users_state
            this.users = response.data.users
            this.todayTenders = response.data.today_tenders  
            this.allTenders = response.data.all_tenders
            this.activeTenders = response.data.active_tenders
        })


        // if(this.$route.query.to){
        //     const element = document.getElementById(this.$route.query.to);
        //     const yOffset = 700;
        //     const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        //     window.scrollTo({top: y, behavior: 'smooth'});
        // }

    },
    watch:{
        $route (to, from){
            if(this.$route.query.to){
                this.$refs.pricingTable.scrollIntoView({ block: 'end', scrollBehavior: 'smooth' })
            }
        },
    },
    created(){
        if(this.$route.query.to){
                // this.$refs.pricingTable.scrollIntoView({top: 700, behavior: 'smooth'})
                const element = document.getElementById(this.$route.query.to);
                const yOffset = 700;
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
            }
    },
    computed:{
        me() {
            return this.$store.getters['user/me']
        },
        pricings() {
            return this.$store.getters['pricing/pricing']
        },
        userType(){
            return this.$store.getters.userType
        },
        isAuthenticated() {
            return this.$store.getters.isAuthenticated
        },   
    },
    validations: {
        email: {email, required}
    },
    methods: {
        consoleLog(data){
            console.log(data)
        },
        activateFreePeriod(){
            if(this.isAuthenticated === false){
                this.$fire({
                    text: "Խնդրում ենք մուտք գործել համակարգ փաթեթը ակտիվացնելու համար",
                    type: "info",
                    confirmButtonText: 'Մուտք գործել',
                }).then((result) => {
                    if (result.value) {
                        this.$router.push(`/login`);
                    }
                })
            } else {
                this.$confirm(
                    "Ակտիվացնել Գոլդ փաթեթ 10 օրով", 
                    "Ակտիվացնել", 
                    "", 
                    {
                        title: 'Do you want to save the changes?',
                        confirmButtonText: 'Ակտիվացնել', 
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                    }
                ).then((result) => {
                    if(result){
                        this.$client.post('gold/package/probation/activate').then((value) => {
                            this.$store.dispatch('user/me')
                            this.$fire({
                                text: "Դուք հաջողությամբ ակտիվացրեցիք Գոլդ փաթեթը 10 օրով",
                                confirmButtonText: 'Լավ'
                            })
                        })
                    }
                })
            }
        },
        activateStateFreePeriod(){
            if(this.isAuthenticated === false){
                this.$fire({
                    text: "Խնդրում ենք մուտք գործել համակարգ փաթեթը ակտիվացնելու համար",
                    type: "info",
                    confirmButtonText: 'Մուտք գործել',
                }).then((result) => {
                    if (result.value) {
                        this.$router.push(`/login`);
                    }
                })
            } else {
                this.$confirm(
                    "Ակտիվացնել Գոլդ փաթեթ 10 օրով", 
                    "Ակտիվացնել", 
                    "", 
                    {
                        title: 'Do you want to save the changes?',
                        confirmButtonText: 'Ակտիվացնել', 
                        cancelButtonText: 'Չեղարկել'
                    }
                ).then((result) => {
                    if(result){
                        this.$client.post('gold/package/probation/activate/order_state').then((value) => {
                            this.$store.dispatch('user/me')
                            this.$fire({
                                text: "Դուք հաջողությամբ ակտիվացրեցիք Գոլդ փաթեթը 10 օրով",
                                confirmButtonText: 'Լավ'
                            })
                        })
                    }
                })
            }
        },
        onWaypoint ({ going, direction }) {
        // going: in, out
        // direction: top, right, bottom, left
            if ((going === this.$waypointMap.GOING_IN) && this.scroll === false ) {
                   for (let i = 1; i < 6; i++) {
                        this.$refs["ICountUp"+i].reset()
                        this.$refs["ICountUp"+i].start()
                 }
                this.scroll = true;
            }
            if (direction === this.$waypointMap.DIRECTION_TOP) {
                console.log('waypoint going top!')
            }
        },
        viewMore(id){
            this.id = id
            this.forHeight = !this.forHeight
            this.showHideFeature = !this.showHideFeature
        },
        viewPrices(item){
            if(item.packageHeader !== 'Անվճար փաթեթ'){
                const element = this.packageBlockContent.find(i => i.id === item.id)
                element.changeBoolean = true
                this.changeStyles = true
            }else if(item.packageHeader === 'Անվճար փաթեթ'){
                if(this.isAuthenticated === false){
                    this.$fire({
                        text: "Խնդրում ենք մուտք գործել համակարգ փաթեթը ակտիվացնելու համար",
                        type: "info",
                        confirmButtonText: 'Մուտք գործել',
                    }).then((result) => {
                        if (result.value) {
                            this.$router.push(`/login`);
                        } else {
                        }
                    })
                }
            }
        },
        viewPricesForState(item){
                const element = this.packageBlockContentForState.find(i => i.id === item.id)
                element.changeBoolean = true
                this.changeStyles = true
                if(this.isAuthenticated === false){
                    this.$fire({
                        text: "Խնդրում ենք մուտք գործել համակարգ փաթեթը ակտիվացնելու համար",
                        type: "info",
                        confirmButtonText: 'Մուտք գործել',
                    }).then((result) => {
                        if (result.value) {
                            this.$router.push(`/login`);
                        } else {
                        }
                    })           
                }
        },
        hidePrices(item){
            const element = this.packageBlockContent.find(i => i.id === item.id)
            element.changeBoolean = false
            this.changeStyles = false
        },
        getSum(k, item, selectedPackage){
            this.packageId = selectedPackage.id;
            this.selectedPrice = selectedPackage.price[`price_${k[2]}`].month;
            const element = this.packageBlockContent.find(i => i.id === item.id)
            const otherElements = this.packageBlockContent.filter(i => i.id !== item.id)
            otherElements.forEach(otherElement => {
                otherElement.cash = null
            });
            element.cash = k[1].slice(0, -5)
        },
        buyPackage(){
            if(this.isAuthenticated === false){
                this.$fire({
                    text: "Խնդրում ենք մուտք գործել համակարգ փաթեթ գնելու համար",
                    type: "info",
                    confirmButtonText: 'Մուտք գործել',
                }).then((result) => {
                    if (result.value) {
                        this.$router.push(`/login`);
                    }else {
                        
                    }
                })
            }
        },
        withActivatePackage(){
            this.$notify({
                group: 'foo',
                type: 'error',
                title: 'Դուք ունեք ակտիվ փաթեթ',
                text: 'Հավելյալ հարցերի համար զանգահարել +37491244970'
            })
        },
        submitEmail(){
            this.$v.$touch()
            if(this.$v.$invalid) {
                return
            }
            const email = {
                email : this.email,
            }
            this.$client.post(`news/subscription`, email).then((value) => {
                if(value.data.message.email.Unique){
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: '',
                        text: 'Դուք արդեն ուղարկել եք տվյալ էլ. փոստի հասցեն'
                    })
                }
            })
            .catch((error) => {
                console.log(error)
            })
        }
    },
    data() {
      return {
        usersState: 0,
        users: 0,
        todayTenders: 0,  
        allTenders: 0,
        activeTenders: 0,
        statePrices: null,
        email: '',  
        disabled: false,
        imageUrl: process.env.VUE_APP_URL,
        partners: '',   
        selectedPrice: 3,
        packageId: 0,
        changeStyles: false,
        forHeight: true,  
        id : 0,
        showHideFeature : true,
        scroll:false,
        settings: {
            "dots": true,
            "arrow": true
         },
         columns: [
            {data: 'id', name: 'id'},
            {data: 'title', name: 'title'}
         ],
        options: {
          useEasing: true,
          useGrouping: true,
          separator: '',
          decimal: '.',
          prefix: '',
          suffix: '',
        },
        advantageContent: [{
            imgSrc: 'assets/landing/images/icon_1.jpg',
            titleAdvantage: 'ԻՆՉ ՀՆԱՐԱՎՈՐՈՒԹՅՈՒՆՆԵՐ Է ԸՆՁԵՌՈՒՄ',
            items: ['գնորդները կարող են ինքնուրույն կազմակերպել մրցույթներ /տենդերներ/',
                    'ձեռք բերել շուկայականից ցածր գներով ապրանքներ, աշխատանքներ և ծառայություններ',
                    'ունենալ խնայողություններ կամ ձեռք բերել շուկայում առկա առաջարկներից լավագույնը',
                    'վաճառողները կարող են ներկայացնել իրենց առաջարկները թիրախավորված գնորդներին',
                    'մեծացնել վաճառքի ծավալները'
                    ],
                    
            },
            {
                imgSrc: 'assets/landing/images/icon_2.jpg',
                titleAdvantage: 'ԻՆՉ ԱՌԱՎԵԼՈՒԹՅՈՒՆՆԵՐ ՈՒՆԻ',
                items: ['ապահովում է մրցակցություն',
                        'ունի թափանցիկության բարձր աստիճան',
                        'գնորդները կարող են ինքնուրույն կազմակերպել մրցույթներ',
                        'ապահովում է անվտանգության բարձր աստիճան',
                        'մատչելի է կառավարման համար'
                ],
            },
            {
                imgSrc: 'assets/landing/images/icon_3.jpg',
                titleAdvantage: 'ԻՆՉ ԽՆԴԻՐՆԵՐ Է ԼՈՒԾՈՒՄ',
                items: ['ծախսերի օպտիմալացում',
                        'կոռուպցիոն ռիսկերի կրճատում',
                        'շահավետ առաջարկ փնտրելու ժամանակի կրճատում',
                        'նոր գնորդների բացահայտում',
                        'մրցակիցների և նրանց գնային քաղաքականության բացահայտում'
                ],
            }
        ],
        packageBlockContent: [
            {
                packageHeader: 'Անվճար փաթեթ',
                packageContent: 'iTender համակարգում տենդերների միջոցով գնումներ կատարելու և վաճառելու հնարավորություն',
                buttonContent: 'ակտիվացնել',
                changeBoolean: false,
                id: 1
            },
            {
                packageHeader: 'Էկոնոմ փաթեթ',
                packageText: '',
                packageContent: 'Տենդերների տեղեկատվություն` տենդերներ /պետական, մասնավոր/, մրցակիցներ, հաղթող գներ...',
                buttonContent: 'Գնել',
                changeBoolean: false,
                sumAndMonth: [ ['12 ամիս՝ ', `49 000 դրամ/ամիս`, 12], ['6 ամիս՝ ', '29 000 դրամ/ամիս', 6], ['3 ամիս՝ ', '19 000 դրամ/ամիս', 3] ],
                cash: '',
                id: 2
            },
            {
                packageHeader: 'Պրեմիում փաթեթ',
                packageText: '',
                packageContent: 'էկոնոմ+ ավտոմատացում` տենդերների մասնակցության հայտերի և հաղթելուց հետո ներկայացվող փաստաթղթերի ավտոմատ պատրաստման գործիքներ...',
                buttonContent: 'Գնել',
                changeBoolean: false,
                sumAndMonth: [ ['12 ամիս՝ ', '69 000 դրամ/ամիս', 12], ['6 ամիս՝ ', '49 000 դրամ/ամիս', 6], ['3 ամիս՝ ', '39 000 դրամ/ամիս', 3], ['1 ամիս՝ ', '19 000 դրամ/ամիս', 1] ],
                cash: '',
                id: 3
            },
            {
                freePeriod: '10 օր անվճար',
                packageHeader: 'Գոլդ փաթեթ',
                packageText: '',
                packageContent: 'էկոնոմ+Պրեմիում+ կառավարում` նախահաշվային գներ, հաղթած տենդերների պահեստի ձևավորում և կառավարում, խորհրդատվություն...',
                buttonContent: 'Գնել',
                sumAndMonth: [ ['12 ամիս՝ ', '99 000 դրամ/ամիս', 12], ['6 ամիս՝ ', '69 000 դրամ/ամիս', 6], ['3 ամիս՝ ', '49 000 դրամ/ամիս', 3], ['1 ամիս՝ ', '29 000 դրամ/ամիս', 1] ],
                changeBoolean: false,
                cash: '',
                id: 4
            }
        ],
        packageBlockContentForState: [
            {
                packageHeader: 'Էկոնոմ փաթեթ',
                packageText: '',
                packageContent: 'Գնումների պլանի պատրաստում և «Մեկ անձից» գնման գործընթացների փաստաթղթերի պատրաստում /ԱՆՍԱՀՄԱՆԱՓԱԿ/',
                buttonContent: 'Գնել',
                changeBoolean: false,
                sum: null,
                cash: '',
                id: null,
            },
            {
                packageHeader: 'Պրեմիում փաթեթ',
                packageText: '',
                packageContent: 'Գնումների պլանի պատրաստում, «Մեկ անձի» և մրցակցային ձևերով գնման գործընթացների փաստաթղթերի պատրաստում /ԱՆՍԱՀՄԱՆԱՓԱԿ/',
                buttonContent: 'Գնել',
                changeBoolean: false,
                sum: null,
                cash: '',
                id: null,
            },
            {
                freePeriod: '10 օր անվճար',
                packageHeader: 'Գոլդ փաթեթ',
                packageText: '',
                packageContent: 'Գնումների պլանի պատրաստում, «Մեկ անձի» և մրցակցային ձևերով գնման գործընթացների փաստաթղթերի պատրաստում, պայմանագրերի կառավարում /ԱՆՍԱՀՄԱՆԱՓԱԿ/ և տեխնիկական բնութագրերի էլեկտրոնային կատալոգներից օգտվելու հնարավորություն',
                buttonContent: 'Գնել',
                sum: null,
                changeBoolean: false,
                cash: '',
                id: null,
            }
        ]
      }
    },
    name: 'MyComponent',
    components: {News, PaymentModal, PaymentStateModal, Carousel, Slide },
  }
</script>
<style>
    .partners .VueCarousel-inner{
        align-items: center !important;
    }
</style>

<style  scoped>
  @import '/assets/landing/css/slick.css';
  @import '/assets/landing/css/animate.css';
    .new-container{
        padding: 0 8%;
    }
    .lh{
        line-height: 40px;
        margin: 0 20px;
    }
    .new-title{
        font-size: 47px !important;
        text-align: center !important;
        font-weight: 400 !important;
        color: #0F0E0E !important;
        padding: 21px 0;
        text-transform: uppercase;
        word-spacing: 12px;
        letter-spacing: -1px;
    }
    .title-bg{
        background-color: rgba(30, 123, 184, 0.15);
    }
    .circle{
        background-color: #43B4B2;
        height: 17px;
        width: 17px;
        border-radius: 50%;
        margin-right: 10px;
    }
    .info-block{
        margin-top: 70px;
    }
    .new-title2{
        font-size: 28px;
        font-weight: 500;
        color: black;
        text-align: center;
        width: 100%;
    }
    .new-title2-spacing{
        padding: 12px 0 45px;
    }
    .header-image{
        background: linear-gradient(rgba(31, 124, 184, 1),rgba(67, 180, 179, 1));
    }
    .new-block-style{
        background-color: rgba(30, 123, 183, 1);
        border-radius: 12px;
        box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.25);
        width: calc(100% / 3 - 70px);
        padding: 17px 36px 50px;
        position: relative;
        height: 155px;
    }
    .new-block-style-height{
        height: fit-content !important;
    }
    .new-feat-title{
        color: rgba(255, 255, 255, 1);
        font-size: 20px;
        font-weight: 400;
        text-align: center;
        line-height: 28px;
    }
    .send-input{
        border: 1px solid #1E7BB7;
        background-color: #F8F8F8;
        border-radius: 50px;
        padding: 0 10px;
        width: 505px;
        height: 45px;
        display: flex;
        align-items: center;
    }
    .send-label{
        background-color: #43B4B2;
        border-radius: 50px;
        width: 141px;
        height: 45px;
        color: white;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: -8px;
        right: -4px;
        cursor: pointer;
    }
    .send-block{
        width: fit-content;
        height: fit-content;
        position: relative;
    }
    .view-more{
        background-color: #43B4B2;
        border-radius: 50px;
        position: absolute;
        bottom: -20px;
        right: -40px;
        padding: 12px 14px;
        cursor: pointer;
        z-index: 10;
    }
    .hide{
        display: none;
    }
    .radius{
        border-radius: 12px;
    }
    .video-spacing{
        padding: 113px 0 133px;
    }
    .advantage-block{
        width: calc(100% / 3 - 70px);
        border-radius: 12px;
        background-color: #1E7BB7;
        padding: 30px;
    }
    .line{
        border: 2px solid rgba(97, 176, 227, 1);
        margin: 20px 0;
    }
    .advantage-image-block img{
        border-radius: 50%;
        width: 227px;
        height: 227px;
    }
    .advantage-image-block {
        display: flex;
        justify-content: center;
    }
    .advantage-header{
        font-weight: 400;
        font-size: 18px;
        line-height: 21px;
        padding-top: 34px;
    }
    .advantage-content{
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        padding-left: 15px;
    }
    .advantage-item-block{
        padding-bottom: 30px;
    }
    .advantage-block div:last-child{
        padding-bottom: 0 !important;
    }
    .main-line{
        height: 17px;
        background-color: rgba(30, 123, 184, 0.15);
        margin: 0 0 60px;
    }
    .package-block{
        width: calc(100% / 4 - 25px);
        background: rgba(196, 196, 196, 0.01);
        border: 1px solid #000000;
        box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 13px;
        position: relative;
    }
    .new-height{
        height: fit-content !important;
    }
    .packages{
        margin: 60px 0 70px;
    }
    .package-header-block{
        background-color: #24323F;
        box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 12px;
        padding: 57px 17px 0;
        height: 190px;
    }
    .package-header-block h1{
        font-weight: 700;
        font-size: 24px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
        margin: 0;
    }
    .package-header-block h2{
        font-weight: 400;
        font-size: 20px;
        text-transform: capitalize;
        color: #FFFFFF;
        text-align: center;
        padding-bottom: 10px;
        margin: 0;
    }
    .free-period{
        background-color: #43B4B2;
        border-radius: 50px;
        padding: 8px 18px;
        font-weight: 400;
        font-size: 24px;
        line-height: 28px;
        color: #FFFFFF;
        position: absolute;
        right: -10px;
        top: -20px;
        cursor: pointer;
    }
    .package-content{
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        text-align: center;
        color: #000000;
        padding: 45px 10px;
        height: 230px;
    }
    .package-btn{
        background: linear-gradient(180deg, #1E7BB7 0%, #43B4B2 100%);
        border-radius: 50px;
        font-weight: 400;
        font-size: 26px;
        line-height: 33px;
        text-transform: uppercase;
        color: #FFFFFF;
        padding: 6px 35px;
        border: 0;
        position: absolute;
        bottom: -1px;
        right: -10px;
    }
    .more-info-btn{
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 18px;
        line-height: 40px;
        color: #1E7BB7;
        border: 0;
        background-color: transparent;
        margin-bottom: 65px;
    }
    .more-info-btn img{
        padding-left: 2px;
    }
    .blue-circle{
        width: 20px;
        height: 20px;
    }
    .sum-text{
        font-weight: 400;
        font-size: 18px;
        line-height: 28px;
        color: #FFFFFF; 
        margin-left: 12px;
        margin-right: 15px;
    }
    .package-sum-block{
        background: #24323F;
        border-radius: 0px 0px 12px 12px;
        padding: 48px 0 40px 20px;
        display: none;
    }
    .pay-btn{
        background: linear-gradient(180deg, #1E7BB7 0%, #43B4B2 100%);
        border-radius: 50px;
        height: 45px;
        width: 108%;
        border: 0;
        position: absolute;
        bottom: -3px;
        left: -4px;
        padding: 0 16px;
        display: none;
    }
    .pay-btn p{
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;
        text-transform: uppercase;
        color: #FFFFFF;
        margin-bottom: 0 !important;
    }
    .cursor{
        cursor: pointer;
    }
    .view-more-spacing{
        margin-top : 28px;
    }
    .send-input::placeholder{
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        text-transform: uppercase;
        color: rgba(0, 0, 0, 0.5);
        vertical-align: middle;
    }
    .new-publics-block{
        margin: 134px 0 111px;
    }
    .new-banner iframe{
        border-radius: 12px !important;
        margin: 0 !important;
    }
    .new-line{
        background-color: rgba(203, 234, 254, 0.15);
        width: 100%;
        position: absolute;
        height: 56px;
        top: 60%;
        left: 0;
    }
    .strong-line{
        background-color: rgba(30, 123, 184, 0.15);
        height: 98px;
        margin-bottom: 60px;
    }
    .more p{ 
        position: absolute;
        bottom: 70px;
        z-index: 111;
        color: white;
        font-size: 18px;
        width: 100%;
        text-align: center;
        left: 0;
        padding: 0 20px;
    }
    .more a{
        font-weight: 400;
        font-size: 36px;
        line-height: 42px;
        text-transform: uppercase;
        color: #FFFFFF;
        background: #1E7BB7;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.5);
        border-radius: 50px;
        height: 45px;
        padding: 0 65px;
        cursor: pointer;
    }
    .font-size{
        font-size: 16px;
        margin-right: 30px;
        margin-left: 30px;
        margin-bottom: 0;
    }
    .sp-block{
        display: flex;
        justify-content: space-around;
    }
    .packages-sp{
        display: flex;
        justify-content: space-between;
    }
    .design{
        background-color: #00000030;
        border-radius: 30px;
    }
    .cursor{
        cursor: pointer;
    }
    .partners img{
        /* max-width: 100%; */
        /* max-height: auto; */
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
        border-radius: 2px;
        transition: filter 0.4s ease-in-out;
    }
    .partners img:hover{
        -webkit-filter: grayscale(0);
        filter: grayscale(0);
    }
    .package-content-state{
        width: auto !important;
    }
    .carousel-block{
        height: 590px;
        overflow: hidden;
    }
    .slide-img{
        margin-top: -50px;
    }
    @media only screen and (max-width: 1850px) {
        .new-banner{
            margin-left: 60px;
        }
    }
    @media only screen and (max-width: 1815px) {
        .new-line{
            top: 59%;
        }
    }
    @media only screen and (max-width: 1761px) {
        .package-content{
            height: 180px;
        }
    }
    @media only screen and (max-width: 1712px) {
        .new-block-style{
            height: 210px;
        }
    }
    @media only screen and (max-width: 1639px) {
        .package-content{
            height: 240px;
        }
    }
    @media only screen and (max-width: 1450px) {
        .package-content{
            height: 230px;
        }
    }
    @media only screen and (max-width: 1400px) {
        .new-container{
            padding-left: 5%;
            padding-right: 5%;
        }
        .header-container{
            padding-left: 5%;
            padding-right: 5%;  
        }
        .new-video-size{
            width: 320px;
            height: 275px;
        }
    }
    @media only screen and (max-width: 1352px) {
        .package-block{
            width: 100%;
            margin: 0 20px;
        }
        .packages-sp{
            justify-content: inherit;
        }
        .package-content{
            height: 195px;
            width: 285px;
        }
        .overflow{
            overflow-y: scroll;
            padding: 0 0 20px 0;
        }
        .free-period{
            top: -1px;
        }
    }
    @media only screen and (max-width: 1309px) {
        .new-line{
            top: 60%;
        }
        .pay-btn p{
            font-size: 18px;
        }
    }
    @media only screen and (max-width: 1308px) {
        .new-line{
            top: 54%;
        }
    }
    @media only screen and (max-width: 1270px) {
        .advantage-block{
            width: calc(100% / 3 - 30px);
        }
        .new-block-style {
            width: calc(100% / 3 - 30px);
        }
        .new-video-size{
            width: 280px;
            height: 235px;
        }
    }
    @media only screen and (min-device-width: 1221px) and (max-device-width: 1252px) {
        .package-block{
            width: calc(100% / 4 - 15px);
        }
    }
    @media only screen and (min-device-width: 1000px) and (max-device-width: 1352px){
        .new-package-content{
            width: 100%;
        }
    }
    @media only screen and (max-device-width: 1199px) {
        .more p{
            bottom: 120px;
        }
        .carousel-block{
            height: auto;
            overflow: inherit;
        }
        .slide-img{
            margin-top: 0;
        }
    }
    @media only screen and (max-width: 1100px) {
        .package-content-state{
            width: 285px !important;
        }
        .new-title2{
            font-size: 20px;
        }
        .mob-feature-block{
            flex-direction: column;
            align-items: center;
        }
        .mob-feature-block div{
            margin-bottom: 30px;
        }
        .new-block-style{
            width: 100%;
            height: auto;
            padding-bottom: 25px;
        }
        .view-more{
            width: fit-content;
            margin: auto;
            right: 0;
            left: 0;
        }
        .new-feat-title{
            font-size: 18px;
        }
        .more-block{
            display: flex;
            justify-content: center;
        }
        .new-title{
            font-size: 30px !important;
        }

        #feature{
            padding: 50px 0;
        }
        .new-container{
            padding-left: 10%;
            padding-right: 10%;
        }
        .advantage-block{
            margin: 0 20px;
            width: 100%;
        }
        #advantage{
            overflow-y: scroll;
        }
        .advantage-image-block{
            width: 400px;
        }
        .advantage-image-block img{
            width: 150px;
            height: 150px;
        }
        .mob-sp{
            padding: 0 0 20px 0;
        }
        .sp-block{
            justify-content: inherit;
        }
        .new-banner{
            display: none;
        }
        .video-sp{
            flex-direction: column;
        }
        .new-video-size{
            width: 400px;
            height: 300px;
            margin-bottom: 20px;
        }
        .video-spacing{
            padding: 40px 0;
        }
        .single-counter .counter-no{
            font-size: 35px;
        }
        .counter-label{
            font-size: 16px;
        }
        .new-line{
            top: 54%;
        }
    }
    @media only screen and (max-width: 1082px) {
        .font-size{
            margin-bottom: 10px;
        }
    }
    @media only screen and (max-width: 1000px) {
        .new-line{
            top: 53%;
        }
        #feature{
            padding: 0;
        }
    }
    @media only screen and (max-width: 992px) {
        .new-line{
            top: 49%;
        }
        .lh{
            line-height: 30px;
        }
    }
    @media only screen and (max-width: 915px) {
        .mob-counter{
            flex-direction: column;
        }
        .new-line{
            display: none;
        }
    }
    @media only screen and (max-width: 768px) {
        .more p{
            font-size: 14px;
        }
    }

    @media only screen and (max-width: 650px) {
        .mob-counter{
            flex-direction: column;
        }
        .new-line{
            display: none;
        }
        .send-block{
            width: 100%;
        }
        .send-input{
            width: 100%;
        }
        .free-period{
            font-size: 20px;
        }
        .more-info-btn{
            font-size: 17px;
            line-height: 70px;
        }
        .new-title{
            font-size: 22px !important;
        }
        .package-header-block h2{
            font-size: 20px;
        }
    }
    @media only screen and (max-width: 600px) {
        .partners img{
            width: 170px;
            height: 140px;
        }
    }
    @media only screen and (max-width: 545px) {
        .new-video-size{
            width: 100%;
            height: 200px;
        }
    }  

    @media only screen and (max-width: 535px) {
        .send-input::placeholder{
            font-size: 10px;
        }
        .send-label{
            width: 80px;
            font-size: 12px;
        }
    }
    @media only screen and (max-width: 500px) {
        .new-title{
            padding: 10px  0 !important;
        }
        .send-input::placeholder{
            font-size: 10px;
        }
        .send-label{
            width: 80px;
            font-size: 12px;
        }
        .advantage-image-block{
            width: 200px;
        }
        .package-content{
            width: 275px;
        }
        .package-content{
            font-size: 16px;
        }
        .single-feature p{
            text-align: left;
        }
        .new-block-style{
            padding-left: 15px;
            padding-right: 15px;
        }
        .new-container{
            padding-left: 5%;
            padding-right: 5%;
        }
        .font-size{
            font-size: 12px;
            margin-bottom: 10px;
        }
        .partners img{
            -webkit-filter: grayscale(0);
            filter: grayscale(0);
        }
        .partners img:hover{
            -webkit-filter: grayscale(0);
            filter: grayscale(0);
        }
    }
    @media only screen and (max-width: 430px) {
        .more p{
            bottom: 15px;
            font-size: 9px;
        }    
        .single-slide img {
            height: 160px;
            min-height: 150px;
        }
        .partners img{
            width: 140px;
            height: 110px;
        }
    }

</style>
